<template>
    <a-modal
        :visible="visible"
        :title="mode == 'create' ? '新增商标标签' : '修改商标标签'"
        @ok="on_submit"
        @cancel="cancel"
        :confirmLoading="submitting"
        :after-close="after_close"
        :width="480"
    >
        <a-form-model :model="form" :rules="rules" ref="_form">
            <a-form-model-item label="名称" prop="name">
                <a-input v-model="form.name"></a-input>
            </a-form-model-item>

            <a-form-model-item label="颜色" prop="color">
                <!-- <a-input v-model="form.color"></a-input> -->
                <Swatches v-model="color" label="选择颜色" />
            </a-form-model-item>

            <!-- <a-form-model-item label="是否在前端展示">
                <a-switch v-model="form.is_front"></a-switch>
            </a-form-model-item> -->

            <a-form-model-item label="禁用" extra="禁用后将不会出现在商标管理的标签列表中">
                <a-switch v-model="form.is_disabled"></a-switch>
            </a-form-model-item>

            <a-form-model-item label="备注">
                <a-input type="textarea" v-model="form.remark"></a-input>
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>
<script>
    import { Swatches } from "vue-color";

    let init_form = { name: null, color: "#000000", is_disabled: false, is_front: false };
    export default {
        props: {
            visible: {
                default: false,
            },
            record: null,
            mode: {
                default: "create",
            },
        },
        components: {
            Swatches,
        },
        created() {
            this.form = init_form;
        },
        data() {
            return {
                submitting: false,
                form: null,
                color: "#111111",
                rules: {
                    name: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "请输入名称",
                        },
                    ],
                    color: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "请输入颜色",
                        },
                    ],
                },
            };
        },
        watch: {
            visible(v) {
                if (v && this.record) {
                    Object.keys(this.form).map((v) => {
                        if (Object.prototype.hasOwnProperty.call(this.record, v)) {
                            switch (v) {
                                case "is_front":
                                case "is_disabled":
                                    this.form["is_disabled"] = !!this.record["is_disabled"];
                                    break;
                                case "color":
                                    this.color = this.record[v];
                                    break;
                                default:
                                    this.form[v] = this.record[v];
                            }
                        }
                    });
                }
            },
        },
        methods: {
            cancel() {
                this.$emit("close");
            },
            on_submit() {
                 this.form.color = this.color.hex || this.color;

                this.$refs["_form"].validate((valid) => {
                    if (valid) {
                        if (this.mode === "create") {
                            return this.on_store();
                        } else {
                            return this.on_update();
                        }
                    } else {
                        this.$message.error("请检查并填写完需要录入的内容");
                        return false;
                    }
                });
            },
            on_store() {
                this.submitting = true;
                this.$http
                    .post("/trademark/tags", this.form)
                    .then((res) => {
                        if (res.success) {
                            this.cancel();
                            this.$emit("load");
                        } else {
                            this.$message.error(res.message);
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.submitting = false;
                    });
            },
            on_update() {
                this.submitting = true;
                this.$http
                    .put("/trademark/tags/" + this.record.id, this.form)
                    .then((res) => {
                        if (res.success) {
                            this.cancel();
                            this.$emit("load");
                        } else {
                            this.$message.error(res.message);
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.submitting = false;
                    });
            },
            after_close() {
                this.$refs["_form"].resetFields();
                this.form = JSON.parse(JSON.stringify(init_form));
            },
        },
    };
</script>
